import {observer} from "mobx-react";
import {StandardDropDownComponent} from "../../../../components/forms/standard-drop-down/standard-drop-down.component";
import {IPassengerViewModel} from "../../../../services/booking/models/passenger/passenger-view-model.interface";
import React from "react";

interface PassengerPsoCategoryDropDownComponentProps {
    passenger: IPassengerViewModel;
}

export const PassengerPsoCategoryDropDownComponent: React.FC<PassengerPsoCategoryDropDownComponentProps> = observer((props) => {
    const categories = props.passenger.getPsoCategories();
    if(categories.length === 0) {
        return null;
    }

    return (
        <StandardDropDownComponent field={props.passenger.fields.psoCategory} items={categories}/>
    )
});